<div class="input-container">
  <label>{{ label | translate }}</label>
  <ng-select
    [items]="searchResults"
    [(ngModel)]="adminItems"
    [multiple]="true"
    [closeOnSelect]="false"
    [searchable]="true"
    [clearable]="true"
    [loading]="loading"
    [typeahead]="searchInput$"
    [compareWith]="compareWith"
    [appendTo]="'body'"
    [required]="isRequired"
    (clear)="onClearSelection()"
    (change)="onSelectionChange($event)"
    bindLabel="email"
    bindValue="id">

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div class="ng-value-container layout-row layout-align-start-center">
        <span class="ng-value-label br-body-2 font-weight-400">{{ item.firstName }} {{ item.lastName }} ({{ item.email }})</span>
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="admin-option">
        <div class="admin-details">
          <span class="admin-name br-body-2 font-weight-400">{{ item.firstName }} {{ item.lastName }}</span>
          <span class="admin-email br-body-2 font-weight-400">{{ item.email }}</span>
        </div>
      </div>
    </ng-template>

    <ng-template ng-loadingtext-tmp>
      <div class="loading-text br-body-2 font-weight-400">{{'Loading admins' | translate}}</div>
    </ng-template>

<!--    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">-->
<!--      <div class="not-found br-body-2 font-weight-400">-->
<!--        No admins matching "{{ searchTerm }}" were found-->
<!--      </div>-->
<!--    </ng-template>-->
  </ng-select>

</div>
